import { FeServerRouteModel } from '../../messages/message-json';
import { httpPost } from './api';

export interface ApiServerRoute {
    seq: string;
    label: string;
    originID: string;
    destID: string;
    isDecoded: boolean;
    route: FeServerRouteModel;
    dst?: number;
    ete?: number;
}

export enum GetApiRoutesType {
    none = 0,
    preferred = 1,
    codedDeparture = 2,
    both = 3
}

async function decodeRoute(...routes: string[]): Promise<{ routes: FeServerRouteModel[] } | null> {
    return await httpPost<{ routes: FeServerRouteModel[] }>('DecodeAdhocRoute', { routes: routes });
}

async function getRoutesForPair(
    origin: string,
    destination: string,
    type: GetApiRoutesType
): Promise<{ preferred: ApiServerRoute[]; codedRoutes: ApiServerRoute[] } | null> {
    const result = await httpPost<{ prefroutes: ApiServerRoute[]; codedroutes: ApiServerRoute[] }>('GetRoutes', {
        originID: origin,
        destID: destination,
        reqType: type
    });

    if (result) {
        return {
            preferred: result.prefroutes,
            codedRoutes: result.codedroutes
        };
    }

    return result;
}

export default {
    decodeRoute,
    getRoutesForPair
};
